// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { mergeTransactionData, setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";

const AdminWelcomeMsgEditApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/welcome_msg_edit";

    // API実行
    const ExecAdminWelcomeMsgEditApi = async (requestParams) => {
        // 必要なリクエストを定義

        let response = null;
        let error = null;

        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url, requestParams});
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
            dispatch(setMasterData({
                welcomeMsgJson:response['welcome_msg_json'],
            }));
        }
        return { response, error };
    };

    return ExecAdminWelcomeMsgEditApi;
};

export default AdminWelcomeMsgEditApi;